import { getToken } from "@/utils/cookies";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Dashboard from "@/layout/Dashboard.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    redirect: "/home",
    meta: { requireAuth: true },
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("@/views/Home.vue"),
        meta: { requireAuth: true, permission: "Home_Show" }
      },
      {
        path: "/users",
        name: "User",
        component: () => import("@/views/User/Users.vue"),
        meta: { requireAuth: true, permission: "Member_List" }
      },
      {
        path: "/device-and-complex",
        name: "DeviceAndComolex",
        component: () => import("@/views/Device/DeviceAndComplex.vue"),
        meta: { requireAuth: true, permission: "Devices_Show" }
      },
      {
        path: "/complexes",
        name: "Complexes",
        component: () => import("@/views/Complex/Complexes.vue"),
        meta: { requireAuth: true, permission: "Complex_Show" }
      },
      {
        path: "/complex-units/:id",
        name: "ComplexUnits",
        component: () => import("@/views/Complex/ComplexUnits.vue"),
        meta: { requireAuth: true, permission: "ComplexUnits_Show" }
      },
      {
        path: "/device-marketing/:id",
        name: "DeviceMarketing",
        component: () => import("@/views/Device/DeviceMarketing.vue"),
        meta: { requireAuth: true, permission: "Devices_MarketingEdit" }
      },
      {
        path: "/device-timeline/:deviceId",
        name: "DeviceTimeline",
        component: () => import("@/views/Device/DeviceTimeline.vue"),
        meta: { requireAuth: true, permission: "DeviceHistory_Show" }
      },
      {
        path: "/device-logs",
        name: "DeviceLogs",
        component: () => import("@/views/Device/DeviceLogs.vue"),
        meta: { requireAuth: true, permission: "DeviceLog_ViewAll" }
      },
      {
        path: "/device-ota-logs/:deviceId",
        name: "DeviceOtaLogs",
        component: () => import("@/views/Device/DeviceOtaLogs.vue"),
        meta: {
          requireAuth: true,
          permission: "OtaList_ShowLogs"
        }
      },
      {
        path: "/device-ota",
        name: "DeviceOTAList",
        component: () => import("@/views/Device/DeviceOTAList.vue"),
        meta: {
          requireAuth: true,
          permission: "OtaList_Show",
          title: "لیست نسخه‌های دستگاه‌ها"
        }
      },
      {
        path: "/device-ota/add",
        name: "DeviceOTAFormAdd",
        component: () => import("@/views/Device/DeviceOTAForm.vue"),
        meta: {
          requireAuth: true,
          permission: "Ota_Edit",
          title: "افزودن نسخه جدید"
        }
      },
      {
        path: "/game-sms",
        name: "GameSmsList",
        component: () => import("@/views/Game/GameSmsList.vue"),
        meta: {
          requireAuth: true,
          permission: "GameSms_List",
          title: "لیست پیامک‌های بازی"
        }
      },
      {
        path: "/game-sms/add",
        name: "GameSmsFormAdd",
        component: () => import("@/views/Game/GameSmsForm.vue"),
        meta: {
          requireAuth: true,
          permission: "GameSms_Create",
          title: "افزودن پیامک جدید"
        }
      },
      {
        path: "/game-sms/edit/:id",
        name: "GameSmsFormEdit",
        component: () => import("@/views/Game/GameSmsForm.vue"),
        meta: {
          requireAuth: true,
          permission: "GameSms_Edit",
          title: "ویرایش پیامک"
        },
        props: true
      },
      {
        path: "/complex-settings",
        name: "ComplexSettings",
        component: () => import("@/views/Complex/ComplexSettings.vue"),
        meta: {
          requireAuth: true,
          permission: "Complex_Edit"
        }
      },
      {
        path: "/device-settings",
        name: "DeviceSettings",
        component: () => import("@/views/Device/DeviceSettings.vue"),
        meta: {
          requireAuth: true,
          permission: "Devices_Edit"
        }
      },
      {
        path: "/device-ota/:id",
        name: "DeviceOTAFormEdit",
        component: () => import("@/views/Device/DeviceOTAForm.vue"),
        meta: {
          requireAuth: true,
          permission: "Ota_Edit",
          title: "ویرایش نسخه"
        },
        props: true
      },
      {
        path: "/complex-devices/:id",
        name: "ComplexDevices",
        component: () => import("@/views/Device/Devices.vue"),
        meta: { requireAuth: true, permission: "Devices_List" }
      },
      {
        path: "/device-update/:deviceId",
        name: "DeviceOTADeviceForm",
        component: () => import("@/views/Device/DeviceOTADeviceForm.vue"),
        meta: { requireAuth: true, permission: "OtaList_Assignment" },
        props: true
      },
      {
        path: "/complex-roles",
        name: "ComplexPermissions",
        component: () => import("@/views/Complex/ComplexPermissions.vue"),
        meta: { requireAuth: true, permission: "ComplexRole_Show" }
      },
      {
        path: "/complex-customers/:id",
        name: "ComplexCustomers",
        component: () => import("@/views/Complex/ComplexCustomers.vue"),
        meta: { requireAuth: true, permission: "ComplexCustomerMember_Show" }
      },
      {
        path: "/complex-members/:id",
        name: "ComplexMembers",
        component: () => import("@/views/Complex/ComplexMembers.vue"),
        meta: { requireAuth: true, permission: "ComplexMember_Show" }
      },
      {
        path: "/device-advertise/:id",
        name: "DeviceAdvertise",
        component: () => import("@/views/Device/Advertises.vue"),
        meta: { requireAuth: true, permission: "DeviceAdvertise_Show" }
      },
      {
        path: "/device-code-activity/:id",
        name: "DeviceCodeActivity",
        component: () => import("@/views/Device/CodeActivity.vue"),
        meta: { requireAuth: true, permission: "CodeActivity_Show" }
      },
      {
        path: "/device-sms-panel/:id",
        name: "DeviceSmsPanel",
        component: () => import("@/views/Device/DeviceSmsPanel.vue"),
        meta: { requireAuth: true, permission: "SmsContent_View" }
      },
      {
        path: "/device-report-multiplier/:id",
        name: "DeviceReportMultiplier",
        component: () => import("@/views/Device/DeviceReportMultiplier.vue"),
        meta: { requireAuth: true, permission: "Devices_ReportMultiply" }
      },
      {
        path: "/device-pins/:id",
        name: "DevicePins",
        component: () => import("@/views/Device/DevicePins.vue"),
        meta: { requireAuth: true, permission: "Pins_List" }
      },
      {
        path: "/hourse-charge-filter",
        name: "HourseCharge",
        component: () => import("@/views/Device/HourseCharge.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      },
      {
        path: "/device-state/:complexId/:id",
        name: "DeviceState",
        component: () => import("@/views/Device/DeviceState.vue"),
        meta: { requireAuth: true, permission: "Devices_Show" }
      },
      {
        path: "/attendance",
        name: "Attendance",
        component: () => import("@/views/Attendance/Attendances.vue"),
        meta: { requireAuth: true, permission: "Attendance_Show" }
      },
      {
        path: "/complexes/:id/devices/create",
        name: "CreateDevice",
        component: () => import("@/views/Device/AddNewDevice.vue"),
        meta: {
          title: "افزودن دستگاه جدید",
          permission: "Devices_Create"
        }
      },
      {
        path: "/complexes/:id/devices/:deviceId/edit",
        name: "EditDevice",
        component: () => import("@/views/Device/AddNewDevice.vue"),
        props: true,
        meta: {
          title: "ویرایش دستگاه",
          permission: "Devices_Edit"
        }
      },
      {
        path: "/security-image",
        name: "SecurityImage",
        component: () => import("@/views/Support/SecurityImages.vue"),
        meta: { requireAuth: true, permission: "SecurityImage_Show" }
      },
      {
        path: "/device/:id/database",
        name: "DeviceDb",
        component: () => import("@/views/Device/DeviceDb.vue"),
        meta: { requireAuth: true, permission: "DeviceDb_Show" }
      },
      {
        path: "/device-report/:id",
        name: "DeviceReport",
        component: () => import("@/views/Device/DeviceReport.vue"),
        meta: { requireAuth: true, permission: "Reports_List" }
      },
      {
        path: "/device-summary/:id",
        name: "DeviceSummary",
        component: () => import("@/views/Device/DeviceSummary.vue"),
        meta: { requireAuth: true, permission: "Devices_Show" }
      },
      {
        path: "/support",
        name: "Support",
        component: () => import("@/views/Support/Supportes.vue"),
        meta: { requireAuth: true, permission: "Support_List" }
      },
      {
        path: "/profile",
        name: "Profile",
        component: () => import("@/views/User/Profile.vue"),
        meta: { requireAuth: true, permission: "Profile_Show" }
      },
      {
        path: "/reports",
        name: "UserReport",
        component: () => import("@/views/Report/Reports.vue"),
        meta: { requireAuth: true, permission: "Reports_List" }
      },
      {
        path: "/notifications",
        name: "Notifications",
        component: () => import("@/views/Notification/Notifications.vue"),
        meta: { requireAuth: true, permission: "Notification_List" }
      },
      {
        path: "/device-notifications",
        name: "DeviceNotifications",
        component: () => import("@/views/Notification/DeviceNotifications.vue"),
        meta: { requireAuth: true, permission: "NotificationLog_List" }
      },
      {
        path: "/device-sms/:deviceId",
        name: "DeviceSms",
        component: () => import("@/views/Notification/DeviceSms.vue"),
        meta: { requireAuth: true, permission: "DeviceSms_List" }
      },
      {
        path: "/devices-sms-list",
        name: "DevicesSmsList",
        component: () => import("@/views/Notification/DevicesSmsList.vue"),
        meta: { requireAuth: true, permission: "DeviceSms_List" }
      },
      {
        path: "/chart-charge",
        name: "ChartCharge",
        component: () => import("@/views/Chart/charge.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      },
      {
        path: "/chart-pic-pass",
        name: "PicPass",
        component: () => import("@/views/Chart/picpass.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      },
      {
        path: "/chart-device-uses",
        name: "DeviceUser",
        component: () => import("@/views/Chart/deviceUses.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      },
      {
        path: "/chart-rate",
        name: "UserRate",
        component: () => import("@/views/Chart/rate.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      },
      {
        path: "/chart-user-hours",
        name: "UserHours",
        component: () => import("@/views/Chart/userHours.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      },
      {
        path: "/chart-operator",
        name: "ChartOperator",
        component: () => import("@/views/Chart/operator.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      },
      {
        path: "/chart-provinces",
        name: "ChartProvinces",
        component: () => import("@/views/Chart/provinces.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      },
      {
        path: "/excel-export",
        name: "ExcelExport",
        component: () => import("@/views/Device/ExcelExport.vue"),
        meta: { requireAuth: true, permission: "Reports_Export" }
      },
      {
        path: "/excel-device-usage",
        name: "DeviceUsageExcel",
        component: () => import("@/views/Device/DeviceUsageExcel.vue"),
        meta: { requireAuth: true, permission: "DeviceUsage_Excel" }
      },
      {
        path: "/missed-requests",
        name: "MissedRequests",
        component: () => import("@/views/Report/MissedRequests.vue"),
        meta: { requireAuth: true, permission: "Missed_Requests" }
      },
      {
        path: "/chart-unique-user",
        name: "ChartUniqueUser",
        component: () => import("@/views/Chart/uniqueUser.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      },
      {
        path: "/chart-perday-perterminal",
        name: "PerDayPerTerminal",
        component: () => import("@/views/Chart/perDayPerTerminal.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      },
      {
        path: "/member-logs",
        name: "Log_Show",
        component: () => import("@/views/User/Logs.vue"),
        meta: { requireAuth: true, permission: "Member_List" }
      },
      {
        path: "/chart-charge-time",
        name: "ChartChargeTime",
        component: () => import("@/views/Chart/chargeTime.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      },
      {
        path: "/per-unique-user-per-day-per-terminal",
        name: "PerUniqueUserPerDayPerTerminal",
        component: () =>
          import("@/views/Chart/perUniqueUserPerDayPerTerminal.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      },
      {
        path: "/per-user-per-day-per-terminal",
        name: "PerUserPerDayPerTerminal",
        component: () => import("@/views/Chart/perUserPerDayPerTerminal.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      },
      {
        path: "/charge-duration",
        name: "ChargeDuration",
        component: () => import("@/views/Chart/cahrgeDuration.vue"),
        meta: { requireAuth: true, permission: "Chart_Show" }
      }
    ]
  },
  {
    path: "/employeeComplexes",
    name: "EmployeeComplexes",
    component: () => import("@/views/Complex/Complexes.vue"),
    meta: { requireAuth: true, permission: "Complex_Show" }
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login/index.vue")
  },
  {
    path: "/get-code",
    name: "GetCode",
    component: () => import("@/views/Login/get-code.vue")
  },
  {
    path: "/verify-code",
    name: "VerifyCode",
    component: () => import("@/views/Login/verifyCode.vue")
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: () => import("@/views/Login/change-password.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = getToken();
  if (to.matched.some(record => record.meta.requireAuth) && !isLoggedIn) {
    next({ path: "/login", query: { returnUrl: to.path } });
    return;
  }

  next();
});

export default router;
